import api from "@/service/api";
import { widget } from "@/lib/charting_library.min.js";
import config from "@/components/Dashboard/dashboardCommon/tradingView/config";
import DataFeeds from "@/components/Dashboard/dashboardCommon/tradingView/datafeed.js";
import { SpecialTreatment } from "@/tools/filter";

const checkTime = (sup) => {
  if (sup >= 10) return sup;

  return `0${sup}`;
};

export default {
  namespaced: true,
  state: () => ({
    apiName: "markPriceBySymbol",
    pricePrecision: 3,
    pair: "BTC:USDT",
    totalKlines: [],
    widgetTVOk: true,
    widgetTV: null,
    containerId: "mark-price-line",
    onRealTimeCallback: null,
    data: [],
    timeList: [
      {
        name: "1 Min",
        interval: "1",
        apiInterval: "1",
        active: "1m-candle",
        chartType: 1,
        timeLen: 1,
      },
      {
        name: "1 Hour",
        interval: "60",
        apiInterval: `5`,
        active: "1h-candle",
        chartType: 1,
        timeLen: 60,
      },
      {
        name: "1 Day",
        interval: "1D",
        apiInterval: `7`,
        active: "1d-candle",
        chartType: 1,
        timeLen: 24 * 60,
      },
      {
        name: "1 Week",
        interval: "1W",
        apiInterval: `8`,
        active: "1w-candle",
        chartType: 1,
      },
      {
        name: "1 Month",
        interval: "1M",
        apiInterval: `9`,
        active: "1M-candle",
        chartType: 1,
      },
    ],
    timeListActive: {
      name: "1 Min",
      interval: "1",
      apiInterval: "1",
      active: "1m-candle",
      chartType: 1,
      timeLen: 1,
    },
    height: 0,
    getPriceBySymbolNoData: false,
    async getPriceBySymbolFunc(endTime, concat = false) {
      const limit = 1000;

      const data = await api[this.apiName]({
        pair: this.pair,
        endTime,
        limit,
        type: this.timeListActive.apiInterval,
      });

      this.getPriceBySymbolNoData = data.length < limit;

      const rewriteData = data.map((ele) => ({
        time: Number(ele[0]),
        low: Number(ele[1]),
        high: Number(ele[2]),
        open: Number(ele[3]),
        close: Number(ele[4]),
        volume: Number(0),
      }));

      if (concat) {
        this.data = rewriteData.concat(this.data);
      } else {
        this.data = rewriteData;

        this.height = data.blockHeight;
      }
    },
  }),
  getters: {},
  mutations: {
    SET_API_NAME(state, data) {
      state.apiName = data;
    },
    SET_WIDGET_OK(state, data) {
      state.widgetTVOk = data;
    },
    SET_LINE_DATA(state, data) {
      state.data = data.map((ele) => ({
        time: Number(ele[0]),
        low: Number(ele[1]),
        high: Number(ele[2]),
        open: Number(ele[3]),
        close: Number(ele[4]),
        volume: Number(0),
      }));
    },

    SET_WIDGET_TV(state, data) {
      state.widgetTV = data;
    },

    SET_TIME_ACTIVE(state, data) {
      state.timeListActive = data;
    },

    UPDATE_HEIGHT(state, height) {
      state.height = height;
    },
    SET_PAIR(state, pair) {
      state.pair = pair;
    },
  },
  actions: {
    updatePriceBySymbol({ commit, state }, opt) {
      opt.forEach((ele) => {
        commit("UPDATE_HEIGHT", ele.blockHeight);
        state.onRealTimeCallback({
          time: Number(ele[0]),
          low: Number(ele[1]),
          high: Number(ele[2]),
          open: Number(ele[3]),
          close: Number(ele[4]),
          volume: Number(0),
        });
      });
    },

    async widgetTV({ commit, state }) {
      await commit(
        "SET_WIDGET_TV",
        new widget({
          debug: false,
          symbol: SpecialTreatment.setPair(state.pair.toUpperCase()),
          timezone: "Asia/Shanghai",
          fullscreen: false,
          interval: state.timeListActive.interval,
          container_id: state.containerId,
          library_path: "/charting_library/",
          locale: "en",
          autosize: true,
          datafeed: new DataFeeds(
            state,
            state.pair,
            state.timeListActive.apiInterval,
            state.pricePrecision
          ),
          theme: "Dark",
          toolbar_bg: "#101314",
          precision: 3,
          drawings_access: {
            type: "black",
            tools: [{ name: "Regression Trend" }],
          },
          customFormatters: {
            timeFormatter: {
              format: (date) => {
                const _format_str = "%h:%m:%s";
                return _format_str
                  .replace("%h", checkTime(date.getUTCHours()), 2)
                  .replace("%m", checkTime(date.getUTCMinutes()), 2)
                  .replace("%s", checkTime(date.getUTCSeconds()), 2);
              },
            },
            dateFormatter: {
              format: (date) => {
                const format = "YYYY-MM-DD";

                return format
                  .replace("YYYY", date.getUTCFullYear(), 2)
                  .replace("MM", checkTime(date.getUTCMonth() + 1), 2)
                  .replace("DD", checkTime(date.getUTCDate()), 2);
              },
            },
          },
          ...config,
        })
      );
    },

    async getInfo({ dispatch, state, commit }, opt) {
      commit("SET_WIDGET_OK", true);
      commit("SET_API_NAME", opt);
      await state.getPriceBySymbolFunc(0);
      await dispatch("widgetTV");
      state.widgetTV.onChartReady(() => {
        commit("SET_WIDGET_OK", false);
      });
    },
  },
};
